import { Checkbox, Group } from "@mantine/core";
import type { Control } from "react-hook-form";
import { useController } from "react-hook-form";
import { FormFieldDateInput } from "../../../BuildingBlocks/Forms/MantineFormFields/fields/FormFieldDateInput";
import type { TodoFormValues } from "../TodoForm.constants";
import { TODO_FORM_FIELD_DATA } from "../TodoForm.constants";

export interface DueDateWithOverdueFieldsProps {
  control: Control<TodoFormValues>;
}

function DueDateWithOverdueFields({ control }: DueDateWithOverdueFieldsProps) {
  const {
    field: dueDateField,
    fieldState: { error: dueDateError }
  } = useController({
    control,
    name: TODO_FORM_FIELD_DATA.dueDate.name
  });
  const { field: overdueField } = useController({
    control,
    name: TODO_FORM_FIELD_DATA.overdue.name
  });

  function handleOverdueChange() {
    if (overdueField.value) {
      overdueField.onChange(false);
    } else {
      overdueField.onChange(true);
    }
  }

  return (
    <Group align="flex-end" mb="sm">
      <FormFieldDateInput
        {...TODO_FORM_FIELD_DATA.dueDate}
        disabled={overdueField.value}
        error={dueDateError?.message}
        value={dueDateField.value}
        onChange={dueDateField.onChange}
      />
      <Checkbox
        checked={overdueField.value}
        label={TODO_FORM_FIELD_DATA.overdue.label}
        mb={6}
        onChange={handleOverdueChange}
      />
    </Group>
  );
}

export { DueDateWithOverdueFields };
